import moment from 'moment';

/**
 * Format a date string into a human-readable format.
 * @param date - The date string to format.
 * @param language - The language code for formatting (default is 'fr').
 * @returns A formatted date string or an empty string if the input is invalid.
 */
export function formatDate(
    date: string | moment.Moment | undefined,
    language = 'fr'
): string {
    if (!date) {
        return '';
    }
    const jsDate = moment.isMoment(date) ? date.toDate() : new Date(date);
    if (Number.isNaN(jsDate.getTime())) {
        return '';
    }
    return new Intl.DateTimeFormat(language === 'fr' ? 'fr-CA' : 'en-CA', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    }).format(jsDate);
}
